import {Field, MakeElParams, Row} from '../interfaces/misc';
import {wp_editor_settings} from '../core/params';
import {Multiselect} from '../core/elements';
import {MediaHandler} from './media';
import {StaTop3} from '../shortcodes/top3';

declare var tinyMCE: { execCommand: (a: any, b: any, c: any) => any, get: (a: any) => any };
declare var tinymce: { init: (a: any) => any };
declare var wp: any;

export function mkEl(tag: string, params?: MakeElParams): HTMLElement {
    return makeEl(tag, '', '', params)
}

export function makeEl(tag: string, text?: string, html?: string, params?: MakeElParams): HTMLElement {
    let el: any = document.createElement(tag);
    try {
        if (text) {
            el.innerText = text;
        } else if (params?.text) {
            el.innerText = params.text;
        }

        if (html) {
            el.innerHTML = html;
        } else if (params?.html) {
            el.innerHTML = params.html;
        }

        if (params?.htmlFor) {
            el.htmlFor = params.htmlFor;
        }

        if (params?.data?.length) {
            params.data.forEach((d) => {
                el.dataset[d.name] = d.val.toString();
            })
        }

        if (params?.style?.length) {
            params.style.forEach((s: any) => {
                el.style[s.name] = s.val;
            })
        }

        if (params?.name) {
            el.name = params.name;
        }

        if (params?.target) {
            el.target = params.target;
        }

        if (params?.href) {
            el.href = params.href;
        }

        if (params?.src) {
            el.src = params.src;
        }

        if (params?.srcset) {
            el.srcset = params.srcset;
        }

        if (params?.title) {
            el.title = params.title;
        }

        if (params?.alt) {
            el.alt = params.alt;
        }

        if (params?.type && tag !== 'textarea') {
            el.type = params.type;
        }

        if (params?.id) {
            el.id = params.id;
        }

        if (params?.for) {
            el.htmlFor = params.for;
        }

        if (params?.value) {
            el.value = params.value;
        }

        if (params?.disabled) {
            el.disabled = params.disabled;
        }

        if (params?.class) {
            (el as HTMLElement).classList.add(...params.class);
        }

        if (params?.append?.length) {
            (el as HTMLElement).append(...params.append);
        }

        if (params?.click && typeof params?.click === 'function') {
            el.addEventListener('click', params.click);
        }
    } catch (e) {
        console.error(e, params);
    }

    return el;
}

export function initEditor(id: string) {

    tinyMCE.execCommand("mceRemoveEditor", true, id);
    // tinyMCE.execCommand("mceAddEditor", false, 'template-text');
    // tinyMCE.execCommand('mceAddControl', false, 'template-text');

    // class-wp-editor.php //1676
    tinymce.init({
        selector: `#${id}`,
        height: 350,
        menubar: false,
        language: 'de',
        branding: false,
        plugins: "charmap,colorpicker,hr,lists,media,paste,tabfocus,textcolor,fullscreen,wordpress,wpautoresize,wpeditimage,wpemoji,wpgallery,wplink,wpdialogs,wptextpattern,wpview,image",
        toolbar1: 'formatselect,bold,italic,bullist,numlist,blockquote,alignleft,aligncenter,alignright,link,wp_more,spellchecker,fullscreen,wp_adv,learndash_shortcodes_tinymce',
        toolbar2: "strikethrough,hr,forecolor,pastetext,removeformat,charmap,outdent,indent,undo,redo,wp_help",
        force_br_newlines: true,
        convert_newlines_to_brs: true,
        apply_source_formatting: true
    });

    return tinyMCE.get(id);
}

export function init_wp_editor(id: string) {
    wp.editor.remove(id)
    wp.editor.initialize(id, wp_editor_settings);
    return tinyMCE.get(id)
}

export function getIcon(type: string) {
    let ico = '';
    switch (type) {
        case 'external':
            ico = '<i class="fa fa-external-link" aria-hidden="true"></i>';
            break;
        case 'info':
            ico = '<i class="fa fa-info-circle" aria-hidden="true"></i>';
            break;
        case 'alert':
        case 'warning':
            ico = '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>';
            break;
        case 'video':
            ico = '<i class="fa fa-video-camera" aria-hidden="true"></i>';
            break;
        case 'envelope':
            ico = '<i class="fa fa-envelope" aria-hidden="true"></i>';
            break;
        case 'download':
            ico = '<i class="fa fa-download" aria-hidden="true"></i>';
            break;
        case 'menu':
            ico = '<i class="fa fa-bars" aria-hidden="true"></i>';
            break;
        case 'delete':
            ico = '<i class="fa fa-trash" aria-hidden="true"></i>';
            break;
        case 'sync':
            ico = '<i class="fa fa-refresh" aria-hidden="true"></i>';
            break;
        case 'repeat':
            ico = '<i class="fa fa-repeat" aria-hidden="true"></i>';
            break;
        case 'save':
            ico = '<i class="fa fa-floppy-o" aria-hidden="true"></i>';
            break;
        case 'hb':
            ico = '<i class="fa fa-heartbeat" aria-hidden="true"></i>\n';
            break;
        case 'user':
            ico = '<i class="fa fa-user-plus" aria-hidden="true"></i>\n';
            break;
        case 'eur':
            ico = '<i class="fa fa-eur" aria-hidden="true"></i>\n';
            break;
        case 'left':
            ico = '<i class="fas fa-chevron-left"></i>\n';
            break;
        case 'right':
            ico = '<i class="fas fa-chevron-right"></i>\n';
            break;
        case 'edit':
            ico = '<i class="fa fa-pencil" aria-hidden="true"></i>';
            break;
        case 'times':
            ico = '<i class="fa fa-times" aria-hidden="true"></i>';
            break;
        case 'users':
            ico = '<i class="fa fa-user-plus" aria-hidden="true"></i>';
            break;
        case 'calendar':
            ico = '<i class="fa fa-calendar-check-o" aria-hidden="true"></i>';
            break;
        case 'code':
            ico = '<i class="fa fa-code" aria-hidden="true"></i>';
            break;
        case 'certificate':
            ico = '<i class="fa fa-certificate" aria-hidden="true"></i>\n';
            break;
    }

    return ico;
}

export function getFontello(type: string) {
    let ico = '';
    switch (type) {
        case 'left':
            ico = '<i class="icon-left-open"></i>\n';
            break;
        case 'right':
            ico = '<i class="icon-right-open"></i>\n';
            break;
    }

    return ico;
}

export function createFormRow(r: Row, remover?: boolean) {
    let row = document.createElement('div');
    row.classList.add('row');

    r.fields.forEach((f: Field) => {
        let label = makeEl('label', f.title, null, {for: f.name}) as HTMLLabelElement;
        let field: HTMLElement = null;
        switch (f.type) {
            case 'multiselect':
                let multi = new Multiselect({
                    name: f.name,
                    title: f.title,
                    options: f.options,
                    label: label,
                    class: f?.class
                });
                field = multi.get();
                break;
            case 'attachments':
                field = makeEl('div', null, null, {class: ['attachment-container']});
                let btn = makeEl('input', null, null, {
                    class: ['button', 'primary', 'attach-btn'],
                    id: f.name,
                    name: f.name,
                    value: 'Anhänge hochladen',
                    type: 'button'
                });
                let container = makeEl('div', null, null, {class: ['selected-attachments']})
                if (f.init_media) {
                    new MediaHandler(btn, container);
                }
                field.append(btn, container);
                break;
            case 'checkbox':
                field = makeEl('input', null, null, {id: f.name, name: f.name, value: f?.value, type: 'checkbox'});
                break;
            default:
                field = makeEl(f.type, null, null, {id: f.name, name: f.name, value: f?.value});
                break;
        }

        if (field) {
            if (f?.class) {
                field.classList.add(f.class)
            }

            if (f?.rows) {
                (field as HTMLTextAreaElement).rows = f.rows
            }

            if (f.type === 'select' && f.options) {
                f.options.forEach(o => {
                    let opt = makeEl('option', o.title, null, {
                        value: o.value,
                        disabled: o?.disabled
                    }) as HTMLOptionElement;
                    if (o?.selected) {
                        opt.selected = true;
                    }
                    field.append(opt);
                })
            }
            row.append(label, field);
        }
    })

    if (remover) {
        console.log('add remover', remover);
        row.append(mkEl('span', {html: '&#10006;', class: ['remover'], click: () => row.remove()}))
    }

    return row;
}

export function createFields(rows: Row[]) {
    let elements: HTMLElement[] = [];
    rows.forEach(r => {
        elements.push(createFormRow(r));
    });
    return elements;
}

export function load_top_items() {
    Array.from(document.querySelectorAll('.sta-top3-container'))?.forEach((el: HTMLElement) => {
        new StaTop3(el);
    });
}

export function calcPercent(part: number, whole: number): number {
    // Check for division by zero
    if (whole === 0) {
        console.error('Error: Cannot divide by zero')
        return null;
    }

    // Calculate the percentage
    return (part / whole) * 100;
}

export function getFirstDayOfYear() {
    const currentDate = new Date();
    const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1);
    const day = String(firstDayOfYear.getDate()).padStart(2, '0');
    const month = String(firstDayOfYear.getMonth() + 1).padStart(2, '0');
    const year = firstDayOfYear.getFullYear();
    return `${year}-${month}-${day}`;
}